import { useSelector } from "react-redux";
import { useMemo } from "react";

export default function useIsHuawei50kIv(SelInverter) {
  const Iv_list = useSelector((state) => state.Iv_list || {});

  const isHuawei50k = useMemo(() => {
    if (!Iv_list.seq || !Array.isArray(Iv_list.seq)) return false;
    const index = Iv_list.seq.findIndex((seq) => seq === SelInverter);
    const protocol = Iv_list.iv_protocol?.[index] || "";
    return protocol.toUpperCase() === "HUAWEI_50K";
  }, [Iv_list, SelInverter]);

  return isHuawei50k;
}
